import { useLayoutElements } from 'contexts/LayoutElementsContext/useLayoutElements';
import { useLayoutHeightFromRef } from './useLayoutHeightFromRef';

export function useLayoutElementsHeight() {
  const { appBarRef, pageHeaderRef } = useLayoutElements();

  const { height: appBarHeight } = useLayoutHeightFromRef(appBarRef);
  const { height: pageHeaderHeight } = useLayoutHeightFromRef(pageHeaderRef);

  const commonContentHeight = `calc(100dvh - ${appBarHeight}px)`;

  return {
    appBarHeight,
    pageHeaderHeight,
    commonContentHeight,
  };
}
